import React from 'react';

const MODELS_BY_PROVIDER = {
  whatgrowpro: [
    { value: 'whatgrowpro', label: 'WhatGrowPro Chat' }
  ],
  google: [
    { value: 'gemini-1.5-pro', label: 'Gemini 1.5 Pro' },
    { value: 'gemini-1.5-flash', label: 'Gemini 1.5 Flash' }
  ],
  openai: [
    { value: 'gpt-4o-mini', label: 'GPT-4o Mini' },
    { value: 'gpt-4o', label: 'GPT-4o' },
    { value: 'gpt-3.5-turbo', label: 'GPT-3.5 Turbo' }
  ],
  openrouter: [
    { value: 'deepseek/deepseek-chat', label: 'DeepSeek Chat' }
  ]
};

const DEFAULT_MODEL_BY_PROVIDER = {
  whatgrowpro: 'whatgrowpro',
  google: 'gemini-1.5-pro',
  openai: 'gpt-4o-mini',
  openrouter: 'deepseek/deepseek-chat'
};

export default function AiSettings({ cfg, update }) {
  const provider = cfg.provider || 'google';
  const models = MODELS_BY_PROVIDER[provider] || [];
  const generation = cfg.generation || {};

  const onProviderChange = (nextProvider) => {
    update({
      provider: nextProvider,
      model: DEFAULT_MODEL_BY_PROVIDER[nextProvider] || cfg.model || 'gemini-1.5-pro'
    });
  };

  return (
    <div className="space-y-4 mt-2">
      <div>
        <label className="text-xs font-medium text-gray-600">AI Provider</label>
        <select
          value={provider}
          onChange={(e) => onProviderChange(e.target.value)}
          className="w-full rounded-md border px-3 py-2 text-sm"
        >
          <option value="whatgrowpro">WhatGrowPro</option>
          {/* <option value="google">Google Gemini</option>
          <option value="openai">OpenAI</option> */}
          <option value="openrouter">OpenRouter</option>
        </select>
      </div>

      <div>
        <label className="text-xs font-medium text-gray-600">Model</label>
        <select
          value={cfg.model || DEFAULT_MODEL_BY_PROVIDER[provider]}
          onChange={(e) => update({ model: e.target.value })}
          className="w-full rounded-md border px-3 py-2 text-sm"
        >
          {models.map((m) => (
            <option key={m.value} value={m.value}>{m.label}</option>
          ))}
        </select>
      </div>

      {provider !== 'whatgrowpro' ? (
        <div>
          <label className="text-xs font-medium text-gray-600">API Key</label>
          <input
            type="text"
            placeholder="Enter API key"
            value={cfg.apiKey || ''}
            onChange={(e) => update({ apiKey: e.target.value })}
            className="w-full rounded-md border px-3 py-2 text-sm"
          />
        </div>
      ) : null}

      <div>
        <label className="text-xs font-medium text-gray-600">Prompt Instructions</label>
        <textarea
          value={cfg.prompt?.system || ''}
          onChange={(e) => update({ prompt: { ...(cfg.prompt || {}), system: e.target.value } })}
          className="w-full min-h-[110px] rounded-md border px-3 py-2 text-sm font-mono"
          placeholder="Write instructions for the AI"
        />
        <p className="text-xs text-gray-500 mt-1">
          Incoming user message is injected automatically. Use variables like <code>{'{{userName}}'}</code>.
        </p>
      </div>

      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className="text-xs font-medium text-gray-600">Temperature</label>
          <input
            type="number"
            min="0"
            max="1"
            step="0.1"
            value={generation.temperature ?? cfg.temperature ?? 0.7}
            onChange={(e) => {
              const next = Number(e.target.value);
              update({
                generation: { ...generation, temperature: next },
                temperature: next
              });
            }}
            className="w-full rounded-md border px-3 py-2 text-sm"
          />
        </div>

        <div>
          <label className="text-xs font-medium text-gray-600">Max Tokens</label>
          <input
            type="number"
            value={generation.maxTokens ?? cfg.maxTokens ?? 300}
            onChange={(e) => {
              const next = Number(e.target.value);
              update({
                generation: { ...generation, maxTokens: next },
                maxTokens: next
              });
            }}
            className="w-full rounded-md border px-3 py-2 text-sm"
          />
        </div>
      </div>

      <div>
        <label className="text-xs font-medium text-gray-600">Response Field</label>
        <input
          value={cfg.responseField || 'aiReply'}
          onChange={(e) => update({ responseField: e.target.value, outputVariable: e.target.value })}
          className="w-full rounded-md border px-3 py-2 text-sm"
        />
      </div>
    </div>
  );
}
